import { useState, useEffect } from 'react';
import {
  Table, TableRow, TableCell, TableHead, TableBody,
  Button, IconButton, TextField, MenuItem
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FormModal from '../components/FormModal';
import api from '../api/axios';

export default function Products() {
  const [products, setProducts] = useState([]);
  const [services, setServices] = useState([]);
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(null);

  // Form fields
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [serviceId, setServiceId] = useState('');

  // Load products and services
  const loadProducts = () => api.get('/products').then(res => setProducts(res.data));
  const loadServices = () => api.get('/services').then(res => setServices(res.data));

  useEffect(() => {
    loadProducts();
    loadServices();
  }, []);

  const openModal = (product = null) => {
    setCurrent(product);
    setName(product?.name || '');
    setDescription(product?.description || '');
    setServiceId(product?.service_id || '');
    setOpen(true);
  };

  const save = async () => {
    const payload = { name, description, service_id: serviceId };
    if (!serviceId) {
      alert('Please select a service');
      return;
    }

    if (current) {
      await api.put(`/products/${current.id}`, payload);
    } else {
      await api.post('/products', payload);
    }
    setOpen(false);
    loadProducts();
  };

  const remove = async id => {
    if (window.confirm('Delete product?')) {
      await api.delete(`/products/${id}`);
      loadProducts();
    }
  };

  return (
    <>
      <Button variant="contained" onClick={() => openModal()}>Add Product</Button>

      <Table sx={{ mt: 2 }}>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Service</TableCell>
            <TableCell width="150">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {products.map(p => (
            <TableRow key={p.id}>
              <TableCell>{p.name}</TableCell>
              <TableCell>{p.description}</TableCell>
              <TableCell>{p.service?.name}</TableCell>
              <TableCell>
                <IconButton onClick={() => openModal(p)}><EditIcon /></IconButton>
                <IconButton onClick={() => remove(p.id)}><DeleteIcon /></IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <FormModal
        open={open}
        title={current ? 'Edit Product' : 'Add Product'}
        onClose={() => setOpen(false)}
        onSubmit={save}
      >
        <TextField
          fullWidth
          label="Product Name"
          value={name}
          onChange={e => setName(e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label="Description"
          value={description}
          onChange={e => setDescription(e.target.value)}
          multiline
          rows={3}
          sx={{ mb: 2 }}
        />
        <TextField
          select
          fullWidth
          label="Select Service"
          value={serviceId}
          onChange={e => setServiceId(e.target.value)}
        >
          {services.map(s => (
            <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
          ))}
        </TextField>
      </FormModal>
    </>
  );
}
